import ListSubheader from '@mui/material/ListSubheader';
import MenuItem from '@mui/material/MenuItem';
import { getApartmentMenuItems, IGroupedApartment } from '../../modules/apartments/helpers';

const menuItemSx = { lineHeight: '22px' };

export function renderApartmentMenuItems(apartments: IGroupedApartment[] | null | undefined) {
  return getApartmentMenuItems(apartments).map((item) =>
    item.type === 'item' ? (
      <MenuItem key={item.id} sx={menuItemSx} value={item.id}>
        {item.name}
      </MenuItem>
    ) : (
      <ListSubheader disableSticky key={`group-${item.name}`}>
        {item.name}
      </ListSubheader>
    )
  );
}
